import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["congressPayments", "formCurrency"]
  static values = {
    withoutPayment: Boolean
  }

  connect() {
    this._initializeVisibility()
  }

  togglePaymentFields() {
    const isEnabled = this.congressPaymentsTarget.value === "true"
    this._toggleFormPayAttributes(!isEnabled)

    if (isEnabled) {
      this._updatePayAttributesVisibility()
    } else {
      this.formCurrencyTarget.dispatchEvent(new Event("change"))
    }
  }

  togglePayAttributesByFormCurrency() {
    this._updatePayAttributesVisibility()
  }

  _toggleFormPayAttributes(show) {
    const element = document.querySelector(".form-pay-attributes")
    if (element) {
      if (show) {
        element.classList.remove("d-none")
      } else {
        element.classList.add("d-none")
      }
    }
  }

  _updatePayAttributesVisibility() {
    const currencyValue = this.formCurrencyTarget.value
    const showPayAttributes = !this._isWithoutPayment()

    document.querySelectorAll(".pay-attributes").forEach(el => {
      if (showPayAttributes) {
        el.classList.remove("d-none")
      } else {
        el.classList.add("d-none")
      }
    })

    // Toggle EUR field visibility based on currency
    const eurField = document.querySelector(".normal_registration_form_form_show_in_eur")
    if (eurField) {
      if (currencyValue === "CZK") {
        eurField.classList.remove("d-none")
      } else {
        eurField.classList.add("d-none")
      }
    }
  }

    // $('.regform-form').on('change', '#normal_registration_form_congress_payments', function () {
    //     $('.form-pay-attributes').toggleClass('d-none', $(this).val() === 'true');
    //     if ($(this).val() === 'true') {
    //         $('.pay-attributes').toggleClass('d-none', <%= @congress.without_payment? %>);
    //     } else {
    //         $('#normal_registration_form_form_currency').trigger('change');
    //     }
    // }).on('change', '#normal_registration_form_form_currency', function () {
    //     $('.pay-attributes').toggleClass('d-none', $(this).val() === '')
    //     $('.normal_registration_form_form_show_in_eur').toggleClass('hidden', $(this).val() !== 'CZK')
    // });
    //
    // $('.pay-attributes').toggleClass('d-none', <%= @congress.without_payment? %>);
    // $('.regform-form .form-pay-attributes').toggleClass('d-none', $('.regform-form #normal_registration_form_congress_payments').val() === 'true')
    // $('.regform-form .pay-attributes').toggleClass('d-none', $('.regform-form #normal_registration_form_form_currency').val() === '')
    // $('.regform-form .normal_registration_form_form_show_in_eur').toggleClass('hidden', $('.regform-form #normal_registration_form_form_currency').val() !== 'CZK')

  _initializeVisibility() {
    this._toggleFormPayAttributes(this.congressPaymentsTarget.value !== "true")
    this._updatePayAttributesVisibility()
  }

  // Mirrors RegistrationForm#without_payment?: when the form uses the
  // congress's own payment setup, defer to whether the congress itself
  // takes payment; otherwise it depends on whether the form has its own
  // currency selected.
  _isWithoutPayment() {
    return this.congressPaymentsTarget.value === "true"
      ? this.withoutPaymentValue
      : this.formCurrencyTarget.value === ""
  }
}




